module.exports = __webpack_public_path__ + "img/c03_unitstartechwoadraiderchampion_Normal_ua.5bb910f6.webp";